import * as React from "react";
import { Form, Row, Col, Input, Icon, Button, notification, Tooltip } from "antd";
import FormControl from "components/Forms/FormControl";
import ValidationUtility from "Core/ValidationUtility";
import { FormComponentProps } from "antd/lib/form";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { ConfirmCreditCardRegistrationRequestBody, IConfirmCreditCardRegistrationRequestBody, ICreditCardRegistrationDto } from "Core/Api/Payment/Api";
import AuthContext from "Context/AuthContext";
import { CreditCardRegistrationFormHandler } from "../CreditCardRegistrationFormHandler";
import NotificationUtility from "Core/NotificationUtility";
import { SubmitButton } from "components/SubmitButton";

export interface Props extends FormComponentProps, RouteComponentProps {
    children?: React.ReactNode
    // cardDetails: Array<ICreditCardRegistrationDto>,
    cardDetails: ICreditCardRegistrationDto,
    regId: number,//card registration number passed down from credit card list for specific form 
    cancelButton(): any;
    confirmed(): any;
}

export interface State {
    confirmCancelClicked: boolean,
}

class BaseCreditCardConfirmation extends React.Component<Props, State> {
    static contextType = AuthContext;
    context!: React.ContextType<typeof AuthContext>;
    creditCardRegistrationFormHandler: CreditCardRegistrationFormHandler;

    constructor(props: Props) {
        super(props)
        this.creditCardRegistrationFormHandler = new CreditCardRegistrationFormHandler(props);
        this.ConfirmCreditCard = this.ConfirmCreditCard.bind(this);
        this.onCancel = this.onCancel.bind(this);

        this.state = {
            confirmCancelClicked: false
        }
    }

    onConfirm = () => {
        this.onCancel();
        this.props.confirmed();
    }

    ConfirmCreditCard(event: React.FormEvent) {
        event.preventDefault();

        this.props.form.validateFieldsAndScroll((error, values: ConfirmCreditCardRegistrationRequestBody) => {
            if (!error) {
                //set registration id for card being confirmed
                var i;
                var cardIdConfirm
                var cardDetails = this.props.cardDetails;
                for (i in cardDetails) {
                    if (this.props.regId === cardDetails.id) {
                        cardIdConfirm = cardDetails.id;
                    };
                };

                var chargeAmount = new ConfirmCreditCardRegistrationRequestBody({
                    amountCharged: values.amountCharged
                })

                this.creditCardRegistrationFormHandler
                    .ConfirmCreditCard(cardIdConfirm, chargeAmount)
                    .then(() => {
                        NotificationUtility.success(
                            'Card Registration & Verification Completed',
                            `Card ending with ${cardDetails.cardNumberLastFourDigits} has successfully been registered and verified.`,
                            10,
                            true
                        );
                        //reload card list
                        this.onConfirm();
                    })
                    .catch(x => {
                        NotificationUtility.error('Confirmation Failed', x.message || x, 30, true);
                    });
            }
        })
    }

    onCancel() {
        this.props.cancelButton();
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { form } = this.props;

        return (
            <Form onSubmit={this.ConfirmCreditCard} layout='vertical'>
                <Row type="flex" align="middle" gutter={10} style={{ paddingTop: '15px' }}>
                    <Col xs={{ span: 18, }}
                        sm={{ span: 18, }}
                        md={{ span: 18, }}
                        lg={{ span: 6, }}
                        xl={{ span: 6, }}>
                        <FormControl
                            getFieldDecorator={getFieldDecorator}
                            rules={[
                                ...ValidationUtility.getRequired('Please Enter Charged Amount'),
                                ...ValidationUtility.getChargedAmount(),
                            ]}
                            name="amountCharged"
                            label="Charged Amount">


                            <Input
                                prefix={<Icon type="money-collect" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                placeholder="Charged Amount"
                            />
                        </FormControl>
                    </Col>
                    <Col span={1}>
                        <Tooltip title={'Do not enter a dollar sign in the field.'}>
                            <Icon style={{ color: "black" }} type="info-circle" />
                        </Tooltip>
                    </Col>
                    <Col xs={{ span: 11, }}
                        sm={{ span: 11, }}
                        md={{ span: 11, }}
                        lg={{ span: 6, }}
                        xl={{ span: 6, }}>
                        <SubmitButton type="primary" htmlType="submit" style={{ textAlign: "center" }} >Submit</SubmitButton>
                    </Col>
                    <Col xs={{ span: 7, }}
                        sm={{ span: 7, }}
                        md={{ span: 7, }}
                        lg={{ span: 5, }}
                        xl={{ span: 5, }}>
                        <Button style={{ backgroundColor: "#FF6232", color: 'white' }} onClick={this.onCancel}>Cancel</Button>
                    </Col>
                </Row>
            </Form>
        )
    }
}


const CreditCardConfirmationWithoutRouter = Form.create<Props>({
    name: 'UpdateUserProfileForm',
})(BaseCreditCardConfirmation);

const CreditCardConfirmation = withRouter(CreditCardConfirmationWithoutRouter);

export default CreditCardConfirmation;